/**
 * PATH: apps/quote/src/components/builder/paste-mapping-modal/types.ts
 * PURPOSE: Types, constants, and helpers for PasteMappingModal
 */

export interface PasteColumn {
  id: string
  label: string
  targetField: string | null
  type: 'text' | 'number'
}

export interface ColumnMapping {
  sourceIndex: number
  targetField: string
}

export interface PasteMappingConfig {
  mappings: ColumnMapping[]
  autoDetected: boolean
  savedAt?: string
}

export interface PasteMappingModalProps {
  isOpen: boolean
  onClose: () => void
  pasteData: string[][]
  availableFields: Array<{ id: string; label: string; type: 'text' | 'number'; required?: boolean }>
  savedMapping?: PasteMappingConfig | null
  onApply: (mappings: ColumnMapping[]) => void
  onSaveMapping?: (mappings: ColumnMapping[]) => void
  sectionName: string
}

export const HEADER_PATTERNS: Record<string, string[]> = {
  location: ['location', 'loc', 'area', 'zone', 'room'],
  description: ['description', 'desc', 'item', 'scope', 'work'],
  quantity: ['qty', 'quantity', 'amount', 'count', 'area', 'm2', 'm²'],
  unit: ['unit', 'uom', 'units'],
  productivity_pmpd: ['pmpd', 'productivity', 'prod', 'm²/day', 'm2/day'],
  rate_per_unit: ['rate', '$/m2', '$/m²', 'price', 'unit rate'],
  adjusted_rate: ['adj rate', 'adjusted', 'override', 'adj'],
  labour_chargeout: ['labour', 'labor', 'labour co', 'labour c/o', 'labour $', 'labor $', 'labour total'],
  material_chargeout: ['material', 'materials', 'material co', 'material c/o', 'material $', 'materials $'],
  plant_chargeout: ['plant', 'equipment', 'plant co', 'plant c/o', 'plant $', 'equipment $'],
  subcon_chargeout: ['subcon', 'subcontract', 'subcontractor', 'subcon co', 'subcon c/o', 'subcon $'],
}

export function autoDetectMapping(
  headers: string[],
  availableFields: PasteMappingModalProps['availableFields']
): ColumnMapping[] {
  const mappings: ColumnMapping[] = []
  const usedFields = new Set<string>()
  headers.forEach((header, index) => {
    const normalized = header.toLowerCase().trim()
    for (const [fieldId, patterns] of Object.entries(HEADER_PATTERNS)) {
      if (usedFields.has(fieldId)) continue
      if (!availableFields.some(f => f.id === fieldId)) continue
      if (patterns.some(p => normalized.includes(p) || p.includes(normalized))) {
        mappings.push({ sourceIndex: index, targetField: fieldId })
        usedFields.add(fieldId)
        break
      }
    }
  })
  return mappings
}
